// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"69":"98a92f7a","126":"345122e4","345":"8898d964","557":"51298360","725":"a5d92ac0"}[chunkId] + ".chunk.css";
};